<template>
    <section>
        <router-view></router-view>
    </section>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        name: "app",
        created () {
            this.$root.$on('msgSuccess', (text) => { this.msgSuccess(text) })
            this.$root.$on('msgError', (text) => { this.msgError(text) })
        },
        methods: {
            msgSuccess(text){
                this.$notify({
                    title: 'Success',
                    message: text,
                    type: 'success',
                    position: 'top-right'                    
                });
            },
            msgError(text){
                this.$notify.error({
                    title: 'Error',
                    message: text,
                    position: 'top-right'
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/App.vue